<template>
  <!-- 适配 Vue2 的自定义价格组件 -->
  <div class="vant-price-custom">
    <!-- 货币符号（可选） -->
    <span class="price-symbol" v-if="symbol">{{ symbol }}</span>
    <!-- 整数部分 -->
    <span class="price-integer">{{ integerPart }}</span>
    <!-- 小数部分（有小数时显示） -->
    <span class="price-decimal">.{{ decimalPart }}</span>
  </div>
</template>

<script>
export default {
  name: 'VantPriceCustom',
  // Vue2 声明 props
  props: {
    // 金额（支持数字/字符串）
    value: {
      type: [Number, String],
      required: true,
      default: 0
    },
    // 货币符号（如 ¥、$）
    symbol: {
      type: String,
      default: '¥'
    },
    // 小数位数（默认2位）
    decimalDigits: {
      type: Number,
      default: 2
    }
  },
  // Vue2 计算属性
  computed: {
    // 格式化金额，拆分整数/小数部分
    formatPrice() {
      // 处理空值/非数字，保证兼容性
      const num = Number(this.value) || 0;
      // 保留指定小数位
      const fixedNum = num.toFixed(this.decimalDigits);
      // 拆分整数和小数
      const [integer, decimal] = fixedNum.split('.');
      return {
        integer,
        decimal,
        // 仅当小数非全0时显示小数部分
        hasDecimal: decimal && decimal !== '00'.padEnd(this.decimalDigits, '0')
      };
    },
    // 整数部分
    integerPart() {
      return this.formatPrice.integer;
    },
    // 小数部分
    decimalPart() {
      return this.formatPrice.decimal;
    },
    // 是否显示小数部分
    hasDecimal() {
      return this.formatPrice.hasDecimal;
    }
  }
};
</script>

<style scoped>
/* 贴合 Vant 设计风格的价格样式 */
.vant-price-custom {
  display: inline-flex;
  align-items: baseline; /* 基线对齐，保证视觉协调 */
  font-family: 'DIN-Medium', sans-serif;
  color: #F85730;
}

/* 货币符号样式 */
.price-symbol {
  font-family: "PingFang SC";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  margin-right: 3px;
}

/* 整数部分（大号字体） */
.price-integer {
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
}

/* 小数部分（核心：字号更小） */
.price-decimal {
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  vertical-align: top; /* 上对齐更美观 */
  margin-left: 1px;
}
</style>